import { Loader2, Sprout, WifiOff } from "lucide-react";
import { useTranslation } from "react-i18next";

export type SplashState = "loading" | "expired" | "first-use";

interface SplashLoadingScreenProps {
	state: SplashState;
}

export function SplashLoadingScreen({ state }: SplashLoadingScreenProps) {
	const { t } = useTranslation();

	return (
		<div className="min-h-screen bg-base-100 flex flex-col items-center justify-center gap-6 p-8">
			<div className="h-16 w-16 rounded-2xl bg-primary/10 flex items-center justify-center">
				<Sprout className="h-8 w-8 text-primary" />
			</div>

			{state === "loading" && (
				<>
					<Loader2 className="h-8 w-8 animate-spin text-primary" />
					<p className="text-base-content/60 text-sm">{t("pwa.loading")}</p>
				</>
			)}

			{state === "expired" && (
				<div className="text-center max-w-xs">
					<WifiOff className="h-10 w-10 text-warning mx-auto mb-3" />
					<h2 className="text-lg font-semibold mb-2">
						{t("pwa.sessionExpired")}
					</h2>
					<p className="text-base-content/60 text-sm">
						{t("pwa.sessionExpiredDescription")}
					</p>
				</div>
			)}

			{state === "first-use" && (
				<div className="text-center max-w-xs">
					<WifiOff className="h-10 w-10 text-info mx-auto mb-3" />
					<h2 className="text-lg font-semibold mb-2">
						{t("pwa.firstUseOffline")}
					</h2>
					<p className="text-base-content/60 text-sm">
						{t("pwa.firstUseOfflineDescription")}
					</p>
				</div>
			)}
		</div>
	);
}
